import React, {useContext} from 'react';
import {Avatar, Box, Chip, IconButton, Link, Sheet, Stack, useColorScheme} from '@mui/joy';
import {Circle, DarkMode, LightMode, MenuRounded} from "@mui/icons-material";
import Typography from "@mui/joy/Typography";
import {useLocation} from "react-router";
function NavBar(props: any) {
    const {onChangeStateDrawer, onChangeTheme} = props
    const {mode, setMode} = useColorScheme();
    const location = useLocation();
    return (<Sheet variant='soft'>
            <Stack paddingY={1} alignItems="center" direction={{xs: 'row', sm: 'row'}}
                   spacing={{xs: 1, sm: 2, md: 4}}>
                <Link href="/" variant="plain" underline="none">
                    <Stack direction='row' alignItems='center' spacing={1}>
                        <Typography>
                            <Typography color='primary' fontWeight='lg'>FUMA</Typography>
                            <Typography sx={{color: mode === 'dark' ? 'white' : 'black'}}
                                        fontWeight='lg'>VIPEMAN</Typography>
                        </Typography>
                    </Stack>
                </Link>
                <Stack
                    borderRadius={256} height={{xs: 0, sm: 0, lg: 0}}
                    paddingX={{xs: 0, sm: 4, md: 8, lg: 16, xl: 32}}
                    bgcolor="blueviolet" flexGrow={1}/>
                <Box paddingX={2} display={{xs: 'none', sm: 'flex'}} sx={{gap: 1.5, flexWrap: 'wrap'}}>
                    <Link sx={{borderRadius: 4}} paddingX={1} href="/"
                          variant={location.pathname === '/' ? 'solid' : 'plain'}
                          color={location.pathname === '/' ? 'primary' : 'neutral'}
                          underline="none">Home</Link>
                    <Link sx={{borderRadius: 4}} paddingX={1} href="/works"
                          variant={location.pathname === '/works' ? 'solid' : 'plain'}
                          color={location.pathname === '/works' ? 'primary' : 'neutral'}
                          underline="none">Work</Link>
                    <Link sx={{borderRadius: 4}} paddingX={1} href="/bio"
                          variant={location.pathname === '/bio' ? 'solid' : 'plain'}
                          color={location.pathname === '/bio' ? 'primary' : 'neutral'}
                          underline="none">Bio</Link>
                    <Link sx={{borderRadius: 4}} paddingX={1} href="/contact"
                          variant={location.pathname === '/contact' ? 'solid' : 'plain'}
                          color={location.pathname === '/contact' ? 'primary' : 'neutral'}
                          underline="none">Contact</Link>

                </Box>
                <Avatar
                    variant="solid"
                    color='primary'
                    sx={{borderRadius: 4, width: 32, height: 32}}
                    onClick={onChangeTheme}
                >
                    {mode === 'dark' && (
                        <LightMode sx={{fontSize: 18, color: 'black'}}/>
                    )}
                    {mode === 'light' && (
                        <DarkMode sx={{fontSize: 18, color: 'white'}}/>
                    )}
                </Avatar>
                <Box display={{xs: 'block', sm: 'none'}}>
                    <IconButton onClick={onChangeStateDrawer(null)}>
                        <MenuRounded  sx={{fontSize:32, color:mode === 'dark' ? 'white' : 'black'}}/>
                    </IconButton>
                </Box>
            </Stack>
        </Sheet>
    );
}
export default NavBar;